// extracted by mini-css-extract-plugin
module.exports = {"section":"Footer_section__3I9CO","body":"Footer_body__1w_Bk","title":"Footer_title__1XGwm","lines":"Footer_lines__qAsSK","buttons":"Footer_buttons__2uypO"};